const messages = {
    addPaymentMethods: 'Add Payment Methods',
    paymentTypeId: 'Payment Type',
    paymentType: 'Payment Type',
    paymentsByProvider: 'Monthly payments to providers',
    moneyCollectionPerDay: 'Collection Statistics',
    graphMoneyCollectionPerDay: 'Collection Operations per Day',
    numberMoneyCollectionPerDay: 'Amount of Money Collections per Day',
    companyLegalDataEditedSuccessfully: 'Company legal data edited successfully',
    companyLegalDataNote: 'This information is necessary for some payment documents',
    companyLegalDataAlert: 'This information is necessary for some payment documents',
    companyLegalData: 'Company Legal Data',
    confirmDeletePaymentMethod: 'Confirm Deletion of Payment Method',
    unauthorizedAction: "You don't have authorization to perform this operation",
    unauthorizedStatistics: "You don't have authorization to view this statistics",
    unauthorizedPaymentsStatistics: "You don't have authorization to view payments statistics",
    unauthorizedPaymentsList: "You don't have authorization to view payments list",
    unauthorizedPaymentsTypesList: "You don't have authorization to view payments types list",
    unauthorizedEditCompanyLegalData: "You don't have authorization to edit company legal data",
    unauthorizedBalanceAdjustmentsList:
        "You don't have authorization to view balance adjustments list",
    unauthorizedBalanceAdjustmentsHistory:
        "You don't have authorization to view balance adjustments history",
    unauthorizedCreateBalanceAdjustments:
        "You don't have authorization to create balance adjustment",
    addExternalProvider: 'Add External Provider',
    editExternalProvider: 'Edit External Provider',
    checkNumber: 'Check Number',
    youWantToRemoveExternalProvider: 'You Want to External Provider',
    unauthorizedCreateLockPatient: "You don't have authorization to lock patient",
    quoteLogs: 'Quote Logs',
    modifiedBy: 'Modified By',
    QuoteTransfers: 'Quote Transfers',
    TreatmentTransfers: 'Treatment Transfers',
    allTreatmentTransfers: 'All Treatment Transfers',
    validateInfoInvoice: 'Fill out the information to view the invoice',
    manualCheck: 'Manual Check',
    createManualProviderCheck: 'Create Manual Provider Check',
    manualCheckCreatedSuccessfully: 'Manual provider check created successfully',
    memo: 'Memo',
    amountMustBeGreaterThanZero: 'Amount must be greater than zero',
    memoIsRequired: 'Memo is required',
    providerPaymentHistory: 'Provider payment history',
    paymentHistoryRows: 'payments',
    period: 'Period',
    payDate: 'Pay Date',
    paymentPeriodStartDate: 'Payment period start date',
    paymentPeriodEndDate: 'Payment period end date',
    paymentPeriodStartDateRequired: 'Payment period start date is required.',
    paymentPeriodEndDateRequired: 'Payment period end date is required.',
    paymentPeriodEndOnOrAfterStart: 'Payment period end date must be on or after the start date.',
    source: 'Source',
    printStatus: 'Print Status',
    printed: 'Printed',
    unpublished: 'Unpublished',
    errorLoadingPaymentHistory: 'Error loading provider payment history',
    unauthorizedPaymentHistory: "You don't have authorization to view provider payment history",
    // Invoice-link column (US #1808/#1809)
    linkedInvoice: 'Supporting Invoice',
    noInvoiceLinked: '— No invoice —',
    linkInvoice: 'Link invoice',
    changeInvoice: 'Change invoice',
    removeInvoice: 'Remove',
    invoiceLinkedSuccessfully: 'Invoice linked successfully',
    invoiceUnlinkedSuccessfully: 'Invoice unlinked successfully',
    errorUpdatingInvoiceLink: 'Error updating invoice link',
};

export default messages;
